/*
 * style-units.ts - convert authored sizes for geometry and drawing
 */

import type * as style from './style-schema';

/** Whether a line width is authored in screen units. */
export function isScreen(units: Units): boolean {
    return units === 'pixels' || units === 'points';
}

/** CSS pixels in one typographic point at the configured CSS DPI. */
export function pixelsPerPoint(cssDpi: number): number {
    return cssDpi / 72;
}

/**
 * Metres per normalized width unit for a flat line.
 * @param units authored width units; points are already normalized to pixels
 * @param viewExtent vertical view extent in metres
 * @param imageHeight apparent canvas height times the projection crop factor
 * @returns the multiplier applied to the width stored in the vertex buffer
 */
export function groundScale(
    units: Units, viewExtent: number, imageHeight: number
): number {

    switch (units) {

        case 'pixels':
        case 'points': return viewExtent / imageHeight;
        case 'ratio': return viewExtent;
        case 'meters': return 1;
    }
}

type Units = style.LetteringLayerProperties['line-width-units'];
